var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.recordList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.recordList, border: "", size: "small" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "打卡时间",
                      "min-width": "160",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createBy",
                      label: "打卡人",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(scope.row.createBy || "-"))]
                          },
                        },
                      ],
                      null,
                      false,
                      2123228783
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "signinCategory",
                      label: "签到类型",
                      "min-width": "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getCategoryTagType(
                                      scope.row.signinCategory
                                    ),
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.signinCategory || "-")
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4129003128
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "坐标",
                      "min-width": "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.coordinateX !== null &&
                              scope.row.coordinateX !== undefined
                                ? _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.coordinateX) +
                                        ", " +
                                        _vm._s(scope.row.coordinateY) +
                                        "\n          "
                                    ),
                                  ])
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3009233725
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "coordinateAddress",
                      label: "坐标地址",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.coordinateAddress || "-")
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3291158628
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "照片",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.photo
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "60px",
                                      height: "60px",
                                    },
                                    attrs: {
                                      src: scope.row.photo,
                                      "preview-src-list": [scope.row.photo],
                                      fit: "cover",
                                    },
                                  })
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2903433710
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "视频",
                      "min-width": "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.video
                                ? _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#409EFF" },
                                      attrs: {
                                        href: scope.row.video,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("查看视频")]
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1124934977
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "备注",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(scope.row.remark || "-"))]
                          },
                        },
                      ],
                      null,
                      false,
                      3524365842
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination" },
                [
                  _vm.total > 0
                    ? _c("el-pagination", {
                        attrs: {
                          layout: "prev, pager, next",
                          total: _vm.total,
                          "page-size": _vm.pageSize,
                          "current-page": _vm.currentPage,
                          small: "",
                          background: "",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.currentPage = $event
                          },
                          "current-change": _vm.handlePageChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "40px",
                color: "#909399",
              },
            },
            [_vm._v("\n    暂无打卡记录\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }